/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentCell/view.blocks to change it.
import AssistantAndProvider from './AssistantAndProvider/index'
import Color from './Color/index'
import Name from './Name/index'
import React from 'react'
import Time from './Time/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentCell({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/NotesHeader/Notes/Content/AppointmentCell"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="AppointmentCell.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Color
  viewPath={`${viewPath}/Color`}
/>
<div
  data-testid="AppointmentCell.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Time
  viewPath={`${viewPath}/Time`}
/>
<AssistantAndProvider
  viewPath={`${viewPath}/AssistantAndProvider`}
/>
</div>
</div>
{children}
</React.Fragment>)
}